import moment from 'moment';
import { ProjectRPCSession } from '#/services/session';
import { FreshJobListRequest } from '#/services/jobs/requests';
import { queryProjectClient } from '#/clients';
import { JobsSearchParameters, QueryString, QueryDate } from '#/protobuf/query_pb';

// eslint-disable-next-line import/prefer-default-export
export class JobListSession extends ProjectRPCSession {
  constructor() {
    super();

    this.resetRequestData();
  }

  resetRequestData() {
    this.request = FreshJobListRequest();
    this.jobList = []; // only init list once
    this.resetPageData();
  }

  resetPageData() {
    this.jobList.length = 0; // empty without setting to new array for any watchers

    this.loading = false; // a request is open over the wire
    this.loadedFirstPage = false; // have we loaded a page yet
    this.loadedLastPage = false; // have we loaded the last page yet

    this.pageCursor = 0; // current page
    this.pageSize = 15; // num items per page

    this.errorMessage = undefined;
  }

  applyJobNameFilter(nameFilter) {
    // TODO: this isn't where this should go
    if (this.filterHasChanged()) {
      this.resetRequestData();
    }

    if (!nameFilter) {
      return;
    }
    const queryString = new QueryString();
    queryString.setSearchExact(nameFilter);
    const jobSearchParams = new JobsSearchParameters();
    jobSearchParams.setJobName(queryString);
    this.request.setSearchTerms(jobSearchParams);
  }

  filterSearch(searchTerm, filterDateStart, filterDateFinish) {
    if (!searchTerm && !filterDateStart && !filterDateFinish) {
      return;
    }
    const queryString = new QueryString();
    queryString.setSearchExact(searchTerm);
    const jobSearchParams = new JobsSearchParameters();
    jobSearchParams.setJobName(queryString);
    const queryDate = new QueryDate();

    const newDate = moment(filterDateStart, 'YYYY-MM-DD');
    const formatedDate = newDate.format(); // will return an ISO representation of the date
    console.info(formatedDate);
    queryDate.setSearchExact(formatedDate);
    jobSearchParams.setJobDateFinished(queryDate);
    this.request.setSearchTerms(jobSearchParams);
  }

  filterHasChanged() {
    // TODO: we need to determine if our filter has changed to reset the loadedLastPage and cursor values
    return true;
  }

  async loadPage() {
    if (this.loading || this.loadedLastPage) {
      return false;
    }
    this.loading = true;
    console.info('loading job page', this.pageCursor);

    this.request.setCursor(this.pageCursor);
    // TODO: abstract the header try/catch handling in in parent class
    const headers = await this.headers();
    return new Promise((resolve, reject) => {
      queryProjectClient.listJobs(this.request, headers, (err, response) => {
        if (err != null) {
          console.log('received err from listJobs ', err);
          this.error = err;
          return reject(err);
        }

        const r = response.toObject();
        console.log('promise resolved job page: ', r);
        this.jobList.push(...r.jobsList);
        this.pageCursor = r.nextCursor;
        console.log('PAGE CURSOR', this.pageCursor);

        if (this.pageCursor === -1) {
          console.log('jobs fully loaded');
          this.loadedLastPage = true;
        }
        return resolve();
        // TODO: commit mutations on store to set jobs
        // TODO: remove list from dispatch in job store. - relegate to this session
        // return resolve(response.toObject());
      });
    }).catch((error) => {
      console.warn('error listing jobs', error);
      this.errorMessage = error.message !== '' ? error.message : 'Whoops... Something went wrong.';
    }).finally(() => {
      if (!this.loadedFirstPage) {
        this.loadedFirstPage = true;
      }
      this.loading = false;
    });
  }
}
